import React, { useEffect, useRef, useState } from 'react';
import { getDocument, GlobalWorkerOptions, version as pdfjsVersion } from 'pdfjs-dist';
import 'pdfjs-dist/web/pdf_viewer.css';

// Worker setup
if (!GlobalWorkerOptions.workerSrc) {
  GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';
}
fetch('/pdf.worker.mjs', { method: 'HEAD' }).catch(() => {
  GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsVersion}/pdf.worker.min.js`;
});

const PdfFormViewer = ({ pdfFile, width = '100%', height = '80vh' }) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageCanvases, setPageCanvases] = useState([]);

  useEffect(() => {
    const loadPdf = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = pdfFile.startsWith('data:application/pdf')
          ? await fetch(pdfFile)
          : await fetch(pdfFile);
        if (!response.ok && !pdfFile.startsWith('data:application/pdf')) throw new Error(`Failed to fetch PDF at ${pdfFile}`);
        const data = pdfFile.startsWith('data:application/pdf')
          ? await (await fetch(pdfFile)).arrayBuffer()
          : await response.arrayBuffer();
        const pdf = await getDocument({ data }).promise;
        const tempPages = [];
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1.0 });
          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          const ctx = canvas.getContext('2d');
          await page.render({ canvasContext: ctx, viewport }).promise;
          tempPages.push({ pageNum, canvas });
        }
        setPageCanvases(tempPages);
        setLoading(false);
      } catch (e) {
        setError(e.message);
        setLoading(false);
      }
    };
    if (pdfFile) loadPdf();
  }, [pdfFile]);

  return (
    <div ref={containerRef} style={{ width, height, overflow: 'auto', background: '#fff', borderRadius: 6, border: '1px solid #ccc', position: 'relative' }}>
      {loading && <div style={{ padding: 40, textAlign: 'center' }}>Loading PDF...</div>}
      {error && <div style={{ color: 'red', padding: 40 }}>{error}</div>}
      {!loading && !error && pageCanvases.map(({ pageNum, canvas }) => (
        <div key={pageNum} style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
          <canvas ref={node => { if (node) node.replaceWith(canvas); }} style={{ maxWidth: '100%', height: 'auto', borderRadius: 6 }} />
        </div>
      ))}
    </div>
  );
};

export default PdfFormViewer;
